import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Donations.css";

function Donations({ isOpen, onClose }) {
  const { t } = useTranslation();
  const [equipmentAddress] = useState("1Fe1oZ7raVetqepXX3nyEFG2Gut4Gcb9D");
  const [teacherAddress] = useState("1JCUNVsebXz9QkHY8kWNpApqcasNYAJv5E");
  const [copied, setCopied] = useState({ equipment: false, teacher: false });

  const copyToClipboard = (address, type) => {
    navigator.clipboard.writeText(address).then(() => {
      setCopied(prev => ({ ...prev, [type]: true }));
      setTimeout(() => setCopied(prev => ({ ...prev, [type]: false })), 2000);
    });
  };

  if (!isOpen) return null;

  return (
    <div className="donations-overlay" onClick={onClose}>
      <div className="donations-modal" onClick={(e) => e.stopPropagation()}>
        <button className="donations-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 className="donations-title">{t("donations.title")}</h2>
        
        <div className="donations-sections">
          <div className="donation-section">
            <h3 className="donation-section-title">{t("donations.equipmentTitle")}</h3>
            <p className="donation-description">{t("donations.equipmentDescription")}</p>
            {equipmentAddress ? (
              <div className="donation-address-container">
                <div className="qr-code-container">
                  <img 
                    src={`${process.env.PUBLIC_URL}/assets/images/onchain-workshop.jpg`}
                    alt="Bitcoin QR code for workshop materials donations"
                    className="qr-code-image"
                  />
                </div>
                <div className="bitcoin-address-wrapper">
                  <a 
                    href={`bitcoin:${equipmentAddress}`}
                    className="bitcoin-address-link"
                  >
                    <span className="bitcoin-icon">₿</span>
                    <span className="bitcoin-address-text">{equipmentAddress}</span>
                  </a>
                  <button
                    onClick={() => copyToClipboard(equipmentAddress, "equipment")}
                    className="copy-address-button"
                    aria-label="Copy address"
                    title={copied.equipment ? "Copied!" : "Copy address"}
                  >
                    {copied.equipment ? (
                      <span className="copy-icon">✓</span>
                    ) : (
                      <svg className="copy-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            ) : (
              <p className="donation-coming-soon">{t("donations.comingSoon")}</p>
            )}
          </div>

          <div className="donation-section">
            <h3 className="donation-section-title">{t("donations.teacherTitle")}</h3>
            <p className="donation-description">{t("donations.teacherDescription")}</p>
            {teacherAddress ? (
              <div className="donation-address-container">
                <div className="qr-code-container">
                  <img 
                    src={`${process.env.PUBLIC_URL}/assets/images/onchain-teacher.jpg`}
                    alt="Bitcoin QR code for workshop instructor donations"
                    className="qr-code-image"
                  />
                </div>
                <div className="bitcoin-address-wrapper">
                  <a 
                    href={`bitcoin:${teacherAddress}`}
                    className="bitcoin-address-link"
                  >
                    <span className="bitcoin-icon">₿</span>
                    <span className="bitcoin-address-text">{teacherAddress}</span>
                  </a>
                  <button
                    onClick={() => copyToClipboard(teacherAddress, "teacher")}
                    className="copy-address-button"
                    aria-label="Copy address"
                    title={copied.teacher ? "Copied!" : "Copy address"}
                  >
                    {copied.teacher ? (
                      <span className="copy-icon">✓</span>
                    ) : (
                      <svg className="copy-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            ) : (
              <p className="donation-coming-soon">{t("donations.comingSoon")}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Donations;

